import React from 'react';
import PropTypes from 'prop-types';
import Option from 'software_products/components/Option';

const OptionsRow = (props) => {
  const { optionValueGroups, selectedOptionIndex, onOptionSelected, isAddingToCart } = props;

  return (
    <div className="row options-row">
      {optionValueGroups.map((optionValueGroup, index) => {
        const { title, subTitle, description, imageUrl } = optionValueGroup;

        return (
          <div key={index} className="col-12 col-lg-4">
            <Option
              index={index}
              imageUrl={imageUrl}
              optionValueGroup={optionValueGroup}
              title={title}
              subTitle={subTitle}
              description={description}
              onSelectOption={(i) => onOptionSelected(i)}
              selected={selectedOptionIndex === index}
              disabled={optionValueGroup.disabled || isAddingToCart}
            />
          </div>
        );
      })}
    </div>
  );
};

OptionsRow.propTypes = {
  selectedOptionIndex: PropTypes.number,
  onOptionSelected: PropTypes.func,
  isAddingToCart: PropTypes.bool,
  optionValueGroups: PropTypes.arrayOf(
    PropTypes.shape({
      licenseTypeName: PropTypes.string,
      activationMethodName: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
};

OptionsRow.defaultProps = {
  optionValueGroups: [],
  selectedOptionIndex: 0,
  isAddingToCart: false,
  onOptionSelected: () => { },
};

export default OptionsRow;